declare global {
  interface Window {
    __ENV__?: {
      API_URL?: string;
    };
  }
}

export function getApiUrl(): string {
  return window.__ENV__?.API_URL ?? '';
}
